import {UI} from "../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../Messages";
import {MerchantButton} from "../../../common/MerchantButton";
import {Flow} from "../../initializeFlows";
import {DONATE_PAGE_URLS} from "../../PanelConstants";
import {LoadingSpinner} from "../../../ui/LoadingSpinner";
import {PoweredByBlink} from "../../PoweredByBlink";
import {registerStyle} from "../../../../stem-core/src/ui/style/Theme";
import {CancelDonationPanelStyle} from "../cancel-donation/CancelDonationPanel";
import {Link} from "../../../../stem-core/src/ui/UIPrimitives";
import {PaymentMethodStore} from "../../../State";
import {Controller} from "../../Controller";


@registerStyle(CancelDonationPanelStyle)
export class PaymentFailedPanel extends UI.Element {
    formatPaymentErrorMessage(message) {
        let formattedMessage = (message || "").toString().trim();

        if (!formattedMessage.length) {
            return formattedMessage;
        }

        if (formattedMessage.slice(-1) !== ".") {
            formattedMessage += ".";
        }

        return formattedMessage;
    }

    render() {
        const {styleSheet} = this;
        return [
            <div testId="donateFailedTitle" className={styleSheet.title}>{Messages.donatePaymentFailed}</div>,
            <div testId="donateFailedMessage" className={styleSheet.text}>
                {[this.formatPaymentErrorMessage(Controller.paymentMethod.getPaymentErrorMessage()), Messages.donateFailedMessage]}
            </div>,
            <MerchantButton className={styleSheet.button} onClick={() => this.options.changeURL(
                PaymentMethodStore.getPrimary() ? DONATE_PAGE_URLS.payWithChosenCard : DONATE_PAGE_URLS.payWithAddedCard, true)}>
                {Messages.editPaymentDetails}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <Link value={Messages.retryPayment} className={styleSheet.link} onClick={() => {
                          LoadingSpinner.show();
                    Flow.donation.donatePageDonate();
                      }}/>
            </div>,
            <PoweredByBlink/>
        ]
    }
}
